import React, { useEffect, useState } from "react";
import { FileText, CalendarClock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHeader, EmptyState, Loader, StatusBadge } from "@/components/dashboard/ui";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function DoctorRequests() {
  const [requests, setRequests] = useState(null);
  const [missions, setMissions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/requests").then(({ data }) => setRequests(data || []));
    api.get("/missions").then(({ data }) => setMissions(data || []));
  }, []);
  if (requests === null) return <Loader />;

  return (
    <div>
      <PageHeader title="Mes demandes & missions" action={<Button className="bg-primary" onClick={() => navigate("/espace/reserver")}>Nouvelle demande</Button>} />
      <Tabs defaultValue="requests">
        <TabsList><TabsTrigger value="requests" data-testid="tab-requests">Demandes ({requests.length})</TabsTrigger><TabsTrigger value="missions" data-testid="tab-missions">Missions ({missions.length})</TabsTrigger></TabsList>
        <TabsContent value="requests" className="mt-4">
          {requests.length === 0 ? <EmptyState icon={FileText} title="Aucune demande" /> : (
            <div className="space-y-3">{requests.map((r) => (
              <div key={r.request_id} className="bg-white rounded-xl border border-slate-200 p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`request-${r.request_id}`}>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap"><span className="font-medium text-slate-900">{(r.services || []).join(", ") || "Demande"}</span>{r.kind === "project" && <span className="text-xs px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700">Projet</span>}</div>
                  <p className="text-sm text-slate-500 mt-1">{r.dates?.[0]?.date ? `${new Date(r.dates[0].date).toLocaleDateString("fr-CH")} · ${r.dates[0].start}–${r.dates[0].end}` : "Accompagnement"}{r.description ? ` — ${r.description}` : ""}</p>
                </div>
                <StatusBadge status={r.status} />
              </div>))}
            </div>
          )}
        </TabsContent>
        <TabsContent value="missions" className="mt-4">
          {missions.length === 0 ? <EmptyState icon={CalendarClock} title="Aucune mission" /> : (
            <div className="space-y-3">{missions.map((m) => (
              <div key={m.mission_id} className="bg-white rounded-xl border border-slate-200 p-4 flex flex-wrap items-center justify-between gap-3">
                <div><p className="font-medium text-slate-900">{new Date(m.date).toLocaleDateString("fr-CH", { weekday: "long", day: "numeric", month: "long" })}</p><p className="text-sm text-slate-500">{m.start} – {m.end} · {(m.services || []).join(", ")}</p></div>
                <StatusBadge status={m.status} />
              </div>))}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
